"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var eventsHelper_1 = require("../utils/eventsHelper");
var Alert = /** @class */ (function () {
    function Alert(rootElement) {
        eventsHelper_1.default.live('.js-close-alert', eventsHelper_1.default.clickOrTouchEvent, function (event, clickedElement) {
            event.preventDefault();
            // If target is toggle hidden trigger element
            if (clickedElement) {
                clickedElement.closest('.alert, .c-alert').classList.add('is-hidden');
            }
        }, rootElement);
    }
    return Alert;
}());
exports.default = Alert;
